// extracted by mini-css-extract-plugin
export var messageSideLeft = "_gm-1";
export var messageSideRight = "_gm-2";
export var orderLookupBubbleContainer = "_gm-0";
export var submitButton = "_gm-3";